<template>
  <PageLayout
    class="account-delete"
    :title="languages.apple_deleteaccount"
    :showLangChoose="false"
    :leftArrow="!hideBackBtn"
    :clickLeft="goBack"
    :showNavBar="!isInPassport"
  >
    <div
      class="section-wrap"
      :class="{
        'safe-padding': isInPassport && !isOldPassport && showSafePadding
      }"
    >
      <div v-for="(component, key) in steps" :key="key">
        <component
          v-show="step == key"
          :is="component"
          :stepKey="key"
          :step="step"
          :gameId="gameId"
          :submitForm="submitForm"
          :isInPassport="isInPassport"
          :isOldPassport="isOldPassport"
          @nextStep="handleNextStep"
          @prevStep="handlePrevStep"
          @updateGameId="updateGameId"
          @updateSubmitForm="updateSubmitForm"
          @setOverlayVisible="setOverlayVisible"
          @deleteCustomSkin="deleteCustomSkin"
        ></component>
      </div>
    </div>
    <van-overlay :show="showOverlay">
      <div class="loading-wrapper" @click.stop>
        <van-loading color="#1989fa" size="40" />
      </div>
    </van-overlay>
  </PageLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import globalConfig from '@utiles/globalConfig';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import ConfirmDeleteType from '@components/officialSupport/accountDelete/ConfirmDeleteType.vue';
import AgreeTerms from '@components/officialSupport/accountDelete/AgreeTerms.vue';
import FormInput from '@components/officialSupport/accountDelete/FormInput.vue';
import EmailNotice from '@components/officialSupport/accountDelete/EmailNotice.vue';
import CoolingOffChoose from '@components/officialSupport/accountDelete/CoolingOffChoose.vue';
import SecondCheckDelete from '@components/officialSupport/accountDelete/SecondCheckDelete.vue';
import DeleteResult from '@components/officialSupport/accountDelete/DeleteResult.vue';
import { stepKey } from '@configs/officialSupport/accountDelete';
import { MAIN_HOST } from '@store/ultile';
import { Overlay, Loading } from 'vant';
const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;
const IS_REVIEW = parseInt(globalConfig.getHrefParam('CacheToken'), 10) || 0;
const IS_IOS = globalConfig.getHrefParam('devicePlate') == 'ios';
const isOldPassport = globalConfig.getHrefParam('isOldPassport') == 1;
const colorConfig = {
  default: {
    'main-color': '#57ae67'
  },
  'YmxhbmNvem9uZS5jb20=': {
    'main-color': '#c0dfff'
  }
};
export default {
  name: 'WorkTemp',
  mixins: [iframeMessage, pointStayTime],
  data() {
    // 判断是否是全面屏
    const judgeBigScreen = () => {
      //  window.screen.height为屏幕高度
      //  window.screen.availHeight 为浏览器 可用高度
      let rate = window.screen.height / window.screen.width;
      let limit =
        window.screen.height == window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
      return rate > limit;
    };
    return {
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '',
      loadingPage: false,
      visibleLoading: true,
      hideBackBtn,
      steps: {
        [stepKey.confirmDeleteType]: 'ConfirmDeleteType',
        [stepKey.agreeTerms]: 'AgreeTerms',
        [stepKey.formInput]: 'FormInput',
        [stepKey.emailNotice]: 'EmailNotice',
        [stepKey.coolingOffChoose]: 'CoolingOffChoose',
        [stepKey.secondCheckDelete]: 'SecondCheckDelete',
        [stepKey.deleteResult]: 'DeleteResult'
      },
      stepKey,
      step: stepKey.confirmDeleteType,
      prevStep: stepKey.confirmDeleteType,
      stepsArr: [],
      submitForm: {
        id: 12,
        isKr: false, //是否IP或语言是韩国
        isJp: false, //是否IP或语言是日本
        isUs: false, //是否IP或语言是美国
        isEu: false, //是否IP或语言是欧盟/英国
        hasSafetyEvent: false, // 最近一个月是否有过非常用IP登录、修改密码或账号找回
        isActDelete: false,
        isNeedCooling: false,
        registrationDate: '',
        phoneModel: '',
        deleteReason: '',
        ipList: '',
        payWay: '',
        payOrderId: '',
        email: '',
        isSumPay: false, // 是否0氪玩家
        gameName: ''
      },
      isInPassport: globalConfig.getHrefParam('isInPassport') == 1,
      isOldPassport,
      showOverlay: false,
      showSafePadding: judgeBigScreen()
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      urlParams: state => state.urlParams,
      curLang: state => state.curLang,
      defaultLang: state => state.defaultLang,
      isLogin: state => state.isLogin,
      loginAccount: state => state.loginAccount
    }),
    isIosReview() {
      return IS_IOS && IS_REVIEW;
    }
  },
  async created() {
    this.initSkin();
    await this.handleLogin();
    await this.initPlayerIndentity();
  },
  mounted() {
    this.initPassportStyle();
  },
  beforeDestroy() {
    this.removeToastStyle();
  },
  watch: {
    step(newVal) {
      if (newVal == stepKey.deleteResult && this.isInPassport) {
        window.parent.postMessage(
          {
            method: 'backLogout'
          },
          window.location.origin
        );
      }
    }
  },
  methods: {
    ...mapActions([
      'submitAiOrder',
      'getIsIpKrOrJp',
      'checkAccountPayInfo',
      'checkLogin'
    ]),
    async handleLogin() {
      return new Promise(resolve => {
        if (this.isLogin) {
          resolve();
        } else {
          this.checkLogin()
            .then(res => {
              resolve(true);
            })
            .catch(() => {
              window.location.href = `https://pay.${MAIN_HOST}/platform/login.html?gameId=${
                this.gameId
              }&forward=${encodeURIComponent(window.location.href)}`;
              return;
            });
        }
      });
    },
    goBack() {
      if (this.isIframe) {
        this.postMessageToParent('goBack');
      } else {
        if (globalConfig.isTiktokMiniProgram()) {
          this.$router.push('/workhome');
        } else {
          this.$router.go(-1);
        }
      }
    },
    async handleNextStep(key) {
      this.prevStep = key;
      this.stepsArr.push(key);
      switch (key) {
        case stepKey.confirmDeleteType: {
          this.step = stepKey.agreeTerms;
          break;
        }
        case stepKey.agreeTerms: {
          // IP或语言是韩国/欧盟/英国，或iOS送审模式 =>下一步：提交通知邮箱
          // IP或语言是美国地区且最近一个月没有过非常用IP登录、修改密码或账号找回 =>下一步：提交通知邮箱
          if (
            this.submitForm.isKr ||
            this.submitForm.isEu ||
            this.isIosReview ||
            (this.submitForm.isUs && !this.submitForm.hasSafetyEvent)
          ) {
            this.step = stepKey.emailNotice;
            return;
          }
          await this.initSumPay();
          this.step = stepKey.formInput;
          break;
        }
        case stepKey.formInput: {
          this.step = stepKey.emailNotice;
          break;
        }
        case stepKey.emailNotice: {
          // iOS送审模式 =>下一步：完成通知
          if (this.isIosReview) {
            this.updateSubmitForm({
              isActDelete: true,
              isNeedCooling: false
            });
            this.setOverlayVisible(true);
            const res = await this.submitAiOrder(this.getDeletParams());
            this.setOverlayVisible(false);
            if (res?.result === 1) {
              this.step = stepKey.deleteResult;
            } else {
              this.$toast(res?.data?.msg || '');
            }
            return;
          }
          // 日韩地区IP或SDK语言日语韩语 =>下一步：选择冷却期
          if (this.submitForm.isKr || this.submitForm.isJp) {
            this.step = stepKey.coolingOffChoose;
            return;
          }
          // 下一步：二次确认删除
          this.updateSubmitForm({
            isNeedCooling: true
          });
          this.step = stepKey.secondCheckDelete;
          break;
        }
        case stepKey.coolingOffChoose: {
          this.step = stepKey.secondCheckDelete;
          break;
        }
        case stepKey.secondCheckDelete: {
          const submitData = {
            ...this.getDeletParams(),
            is_act_delete: true
          };
          if (
            !(
              this.submitForm.isKr ||
              this.submitForm.isEu ||
              this.isIosReview ||
              (this.submitForm.isUs && !this.submitForm.hasSafetyEvent)
            )
          ) {
            Object.assign(submitData, {
              registration_date: this.submitForm.registrationDate,
              phone_model: this.submitForm.phoneModel,
              ip_list: this.submitForm.ipList,
              email: this.submitForm.email
            });
            if (this.submitForm.isSumPay) {
              Object.assign(submitData, {
                pay_way: this.submitForm.payWay,
                pay_order_id: this.submitForm.payOrderId
              });
            }
          }
          this.setOverlayVisible(true);
          const res = await this.submitAiOrder(submitData);
          this.setOverlayVisible(false);
          if (res?.result === 1) {
            this.step = stepKey.deleteResult;
          } else {
            this.$toast(res?.data?.msg || '');
          }
          break;
        }
      }
    },
    handlePrevStep() {
      this.step = this.stepsArr[this.stepsArr.length - 1];
      this.stepsArr.pop();
    },
    updateGameId(gameId) {
      this.gameId = gameId;
    },
    updateSubmitForm(data) {
      Object.assign(this.submitForm, data);
    },
    async initPlayerIndentity() {
      const res = await this.getIsIpKrOrJp();
      if (res?.result === 1) {
        const { IsKr, IsJp, IsUs, IsEu } = res?.data;
        const lang = this.curLang.split('-')[1];
        this.submitForm.isKr = IsKr || ['KR'].includes(lang) || false;
        this.submitForm.isJp = IsJp || ['JP'].includes(lang) || false;
        this.submitForm.isUs = IsUs || ['US'].includes(lang) || false;
        this.submitForm.isEu =
          IsEu ||
          [
            'GB',
            'AT',
            'BE',
            'BG',
            'HR',
            'CY',
            'CZ',
            'DK',
            'EE',
            'FI',
            'FR',
            'DE',
            'GR',
            'HU',
            'IE',
            'IT',
            'LV',
            'LT',
            'LU',
            'MT',
            'NL',
            'PL',
            'PT',
            'RO',
            'SK',
            'SI',
            'ES',
            'SE'
          ].includes(lang) ||
          false;
      }
    },
    getDeletParams() {
      return {
        id: this.submitForm.id,
        email: this.submitForm.email,
        is_act_delete: this.submitForm.isActDelete,
        is_need_cooling: this.submitForm.isNeedCooling,
        game_id: this.gameId,
        appLanguage: this.curLang,
        language: this.curLang,
        is_kr_player: this.submitForm.isKr,
        is_us_player: this.submitForm.isUs,
        is_ios_check_mode: this.isIosReview || false,
        source_type: 2
      };
    },
    async initSumPay() {
      const res = await this.checkAccountPayInfo({
        account: this.loginAccount,
        appLanguage: this.curLang,
        game_id: this.gameId
      });
      if (res?.result === 1) {
        this.submitForm.isSumPay = res?.data?.sum_pay > 0 ? true : false;
      }
    },
    // 兼容旧版用户中心绿色、纯白皮肤
    initSkin() {
      if (isOldPassport) {
        const pt = window.btoa(globalConfig.getMainHost());
        const config = colorConfig[pt] ? colorConfig[pt] : colorConfig.default;
        Object.keys(config).forEach(item => {
          document.documentElement.style.setProperty(`--${item}`, config[item]);
          document.body.style.setProperty(`--${item}`, config[item]);
        });
      }
      this.initToastStyle();
    },
    deleteCustomSkin() {
      if (isOldPassport) {
        const pt = window.btoa(globalConfig.getMainHost());
        const config = colorConfig[pt] ? colorConfig[pt] : colorConfig.default;
        Object.keys(config).forEach(item => {
          document.documentElement.style.removeProperty(`--${item}`);
          document.body.style.removeProperty(`--${item}`);
        });
      }
    },
    setOverlayVisible(visible) {
      this.showOverlay = visible;
    },
    initPassportStyle() {
      if (this.isInPassport) {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
        .van-toast {
          font-size: 26px !important;
          line-height: 26px !important;
        }
      `;
        document.head.appendChild(style);
      }
    },
    initToastStyle() {
      const style = document.createElement('style');
      style.id = 'van-toast-style';
      style.type = 'text/css';
      style.innerHTML = `.van-toast {width: unset !important;}`;
      document.head.appendChild(style);
    },
    removeToastStyle() {
      const style = document.getElementById('van-toast-style');
      if (style) {
        document?.head?.removeChild(style);
      }
    }
  },
  components: {
    PageLayout,
    ConfirmDeleteType,
    AgreeTerms,
    FormInput,
    EmailNotice,
    CoolingOffChoose,
    SecondCheckDelete,
    DeleteResult,
    Overlay,
    Loading
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
.account-delete {
  .section-wrap {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 20px auto 20px;
    &.safe-padding {
      padding-top: 60px;
    }
  }
  .selector {
    background-color: var(--block-bg-light-color);

    ::v-deep .van-picker-column__item {
      color: var(--text-color);
    }
  }
  .loading-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (orientation: landscape) {
  .account-delete {
    .section-wrap {
      padding: 0 50px;
    }
  }
}
</style>
